// Greek category labels.
export const HELP_CATEGORIES = [
  { id: 'getting-started', label: 'Ξεκινώντας', icon: '🚀' },
  { id: 'data', label: 'Προετοιμασία και μεταφόρτωση δεδομένων', icon: '📁' },
  { id: 'analysis', label: 'Εκτέλεση ανάλυσης', icon: '▶️' },
  { id: 'results', label: 'Κατανόηση αποτελεσμάτων', icon: '📊' },
  { id: 'troubleshooting', label: 'Αντιμετώπιση προβλημάτων', icon: '🛠️' },
]
